import { render, staticRenderFns } from "./ListPromotionBulkUpload.vue?vue&type=template&id=68e16fbe"
import script from "./ListPromotionBulkUpload.vue?vue&type=script&lang=js"
export * from "./ListPromotionBulkUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports